import {
  Button,
  Checkbox,
  Classes,
  Dialog,
  FormGroup,
  InputGroup,
  Switch,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { IMva, newIMva } from "../../model";
import { MvaStorePA } from "../../stores/mvas/MvaStorePA";
import { MDBCol, MDBRow } from "mdbreact";
import { toast } from "react-toastify";
import MomentLocaleUtils from "react-day-picker/moment";
import { DateInput } from "@blueprintjs/datetime";
import { getMomentFormatter } from "../../utils";
import * as moment from "moment";
const InputMask = require("react-input-mask");

interface MvaPaDialogCreateProps {
  onClose: () => void;
}

interface MvaPaDialogCreateState {
}

@observer
export class MvaPaDialogCreate
  extends React.Component<MvaPaDialogCreateProps, MvaPaDialogCreateState> {

  obs = observable({
    mva: newIMva() as IMva,
    open_select_segments: false as boolean
  })

  async componentDidMount() {
  }

  /**
  * Valida os dados do objeto MVA e, se válidos, tenta salvá-lo via store.
  *
  * A função:
  * - Realiza validações nos campos obrigatórios do objeto `this.obs.mva`:
  *   - `produto_cest`, `item`, `produto_ncm` são sempre obrigatórios.
  *   - Se `entrada` for true, também valida as alíquotas industriais e de distribuidor para 4%, 7% e 12%.
  *   - Caso contrário, valida as alíquotas de 19%.
  * - Se algum campo obrigatório estiver vazio, exibe um **toast.warning** com a mensagem correspondente e interrompe a execução.
  * - Valida as datas `valido_de` e `valido_ate`, assegurando que `valido_de <= valido_ate`. Caso contrário, exibe um **toast.warning**.
  * - Converte as datas para o formato `YYYY-MM-DD`.
  * - Chama o método `MvaStorePA.doSaveCreateMva(mva)` para salvar os dados.
  * - Se o retorno da store for positivo (`res` for truthy), chama `this.props.onClose()` para fechar o modal ou interface.
  *
  * @async
  * @param {Object} mva Objeto MVA a ser validado e salvo.
  *
  * @returns {Promise<void>} Promise resolvida após tentativa de salvamento.
  */

  handleSaveCreate = async (mva) => {
    if (this.obs.mva.produto_cest == "") {
      toast.warning('Preencha um CEST.', {});
      return;
    }
    if (this.obs.mva.item == "") {
      toast.warning('Preencha o ITEM.', {});
      return;
    }
    if (this.obs.mva.produto_ncm == "") {
      toast.warning('Preencha o NCM', {});
      return;
    }

    if (this.obs.mva.entrada) {

      if (this.obs.mva.margem_industrial_4 == "") {
        toast.warning('Preencha a Alíquota Industrial 4%.', {});
        return;
      }
      if (this.obs.mva.margem_industrial_7 == "") {
        toast.warning('Preencha a Alíquota Industrial 7%.', {});
        return;
      }
      if (this.obs.mva.margem_industrial_12 == "") {
        toast.warning('Preencha a Alíquota Industrial 12%.', {});
        return;
      }
      if (this.obs.mva.margem_distribuidor_4 == "") {
        toast.warning('Preencha a Alíquota Distribuidor 4%', {});
        return;
      }
      if (this.obs.mva.margem_distribuidor_7 == "") {
        toast.warning('Preencha a Alíquota Distribuidor 7%', {});
        return;
      }
      if (this.obs.mva.margem_distribuidor_12 == "") {
        toast.warning('Preencha a Alíquota Distribuidor 12%', {});
        return;
      }

    } else {

      if (this.obs.mva.margem_industrial_19 == "") {
        toast.warning('Preencha a Alíquota Industrial 19%.', {});
        return;
      }
      if (this.obs.mva.margem_distribuidor_19 == "") {
        toast.warning('Preencha a Alíquota Distribuidor 19%', {});
        return;
      }
    }

    var valido_de = mva.valido_de ? moment(mva.valido_de).format("YYYY-MM-DD") : null;
    var valido_ate = mva.valido_ate ? moment(mva.valido_ate).format("YYYY-MM-DD") : null;

    if (valido_de != null && valido_ate != null) {
      if (valido_de > valido_ate) {
        toast.warning('Campo (Valido de) não pode ser maior que (Valido até)', {});
        return;
      }
    }

    mva.valido_de = valido_de
    mva.valido_ate = valido_ate
    let res = await MvaStorePA.doSaveCreateMva(mva);

    if (res) {
      this.props.onClose()
    }

  };

  render() {
    if (!this.obs.mva) {
      return null;
    }
    let dayPickerProps = {
      localeUtils: MomentLocaleUtils,
      locale: "pt-br",
    };

    return (
      <>
        <Dialog
          isOpen={true}
          onClose={this.props.onClose}
          style={{ width: 600, height: 400 }}
        >
          <div className={Classes.DIALOG_HEADER}>
            <div style={{ display: "flex", width: "100%" }}>
              <h2 className="title-no-bottom">Criar MVA</h2>
              <Switch
                checked={this.obs.mva.entrada}
                onChange={(e: any) => this.obs.mva.entrada = e.target.checked}
                innerLabelChecked="Entrada" innerLabel="Saída"
                style={{ marginTop: 12, marginLeft: "auto", fontSize: 12, fontWeight: 600 }}
              />
            </div>
          </div>

          <div className={Classes.DIALOG_BODY}>
            <div style={{ width: "100%", display: "flex"}}>
              <FormGroup style={{marginRight: 25}}
                label="Item"
                labelFor="item"
              >
                <InputGroup
                  id="item"
                  value={this.obs.mva.item}
                  onChange={(e) => this.obs.mva.item = e.target.value}
                />
              </FormGroup>

              <FormGroup style={{marginRight: 25}}
                label="CEST"
                labelFor="cest"
              >
                <InputMask
                  mask="99.999.99"
                  className="form-control"
                  onChange={(e) => this.obs.mva.produto_cest = e.target.value}
                />
              </FormGroup>

              <FormGroup
                label="NCM (separador por vírgula e com ponto)"
                labelFor="ncm"
              >
                <InputMask
                  mask="9999.99.99"
                  className="form-control"
                  onChange={(e) => this.obs.mva.produto_ncm = e.target.value}
                />
              </FormGroup>
            </div>
            <div>
              <FormGroup
                label="Descrição"
                labelFor="descricao"
              >
                <InputGroup
                  id="descricao"
                  onChange={(e) => this.obs.mva.produto_desc = e.target.value}
                />
              </FormGroup>

              <MDBRow xl="12" lg="12" md="12" sm="12" xs="12">
                <MDBCol>
                  <FormGroup label="Valido de">
                    <DateInput
                      {...getMomentFormatter("DD/MM/YYYY")}
                      locale="pt-br"
                      dayPickerProps={dayPickerProps}
                      onChange={(e) => this.obs.mva.valido_de = e}
                      placeholder="DD/MM/AAAA"
                      canClearSelection
                    />
                  </FormGroup>
                </MDBCol>

                <MDBCol>
                  <FormGroup label="Valido até">
                    <DateInput
                      {...getMomentFormatter("DD/MM/YYYY")}
                      locale="pt-br"
                      dayPickerProps={dayPickerProps}
                      onChange={(e) => this.obs.mva.valido_ate = e}
                      placeholder="DD/MM/AAAA"
                      canClearSelection
                    />
                  </FormGroup>
                </MDBCol>
              </MDBRow>

              {this.obs.mva.entrada ?

                <MDBRow xl="12" lg="12" md="12" sm="12" xs="12">
                  <MDBCol>
                    <FormGroup
                      label="Alíquota Industrial 4%"
                      labelFor="margem_industrial_4"
                    >
                      <InputGroup
                        id="margem_industrial_4"
                        onChange={(e) =>
                          this.obs.mva.margem_industrial_4 = e.target.value}
                        placeholder="Exemplo: 54,8950"
                      />
                    </FormGroup>

                    <FormGroup
                      label="Alíquota Industrial 7% "
                      labelFor="margem_industrial_7"
                    >
                      <InputGroup
                        id="margem_industrial_7"
                        onChange={(e) =>
                          this.obs.mva.margem_industrial_7 = e.target.value}
                        placeholder="Exemplo: 54,8950"
                      />
                    </FormGroup>

                    <FormGroup
                      label="Alíquota Industrial 12% "
                      labelFor="margem_industrial_12"
                    >
                      <InputGroup
                        id="margem_industrial_12"
                        onChange={(e) =>
                          this.obs.mva.margem_industrial_12 = e.target.value}
                        placeholder="Exemplo: 54,8950"
                      />
                    </FormGroup>
                  </MDBCol>
                  <MDBCol>
                    <FormGroup
                      label="Alíquota Distribuidor 4%"
                      labelFor="margem_distribuidor_4"
                    >
                      <InputGroup
                        id="margem_distribuidor_4"
                        onChange={(e) =>
                          this.obs.mva.margem_distribuidor_4 = e.target.value}
                        placeholder="Exemplo: 54,8950"
                      />
                    </FormGroup>
                    <FormGroup
                      label="Alíquota Distribuidor 7% "
                      labelFor="margem_distribuidor_7"
                    >
                      <InputGroup
                        id="margem_distribuidor_7"
                        onChange={(e) =>
                          this.obs.mva.margem_distribuidor_7 = e.target.value}
                        placeholder="Exemplo: 54,8950"
                      />
                    </FormGroup>

                    <FormGroup
                      label="Alíquota Distribuidor 12%"
                      labelFor="margem_distribuidor_12"
                    >
                      <InputGroup
                        id="margem_distribuidor_12"
                        onChange={(e) =>
                          this.obs.mva.margem_distribuidor_12 = e.target.value}
                        placeholder="Exemplo: 54,8950"
                      />
                    </FormGroup>

                  </MDBCol>
                </MDBRow>

                :

                <MDBRow xl="12" lg="12" md="12" sm="12" xs="12">
                  <MDBCol>

                    <FormGroup
                      label="Alíquota Industrial 19% "
                      labelFor="margem_industrial_19"
                    >
                      <InputGroup
                        id="margem_industrial_19"
                        onChange={(e) =>
                          this.obs.mva.margem_industrial_19 = e.target.value}
                        placeholder="Exemplo: 54,8950"
                      />
                    </FormGroup>
                  </MDBCol>
                  <MDBCol>
                    <FormGroup
                      label="Alíquota Distribuidor 19%"
                      labelFor="margem_distribuidor_19"
                    >
                      <InputGroup
                        id="margem_distribuidor_19"
                        onChange={(e) =>
                          this.obs.mva.margem_distribuidor_19 = e.target.value}
                        placeholder="Exemplo: 54,8950"
                      />
                    </FormGroup>

                  </MDBCol>
                </MDBRow>

              }
              <MDBRow>
                <MDBCol>
                  <span><b style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => this.obs.open_select_segments = true}>{"Selecione os Segmentos"}</b></span>
                </MDBCol>
              </MDBRow>
            </div>
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Cancelar" onClick={this.props.onClose} />
              <Button
                text="Criar"
                intent="primary"
                onClick={() => this.handleSaveCreate(this.obs.mva)}
              />
            </div>
          </div>
        </Dialog>

        <Dialog
          isOpen={this.obs.open_select_segments}
          onClose={() => this.obs.open_select_segments = false}
          style={{ width: 600, height: 400 }}
        >
          <div className={Classes.DIALOG_BODY}>
            <FormGroup
              label="Selecione os segmentos:"
              labelFor="segmentos"
              >
              <div style ={{overflow: "auto", maxHeight: 400}}>
                <Checkbox
                  label={"Autopeças"}
                  checked={this.obs.mva.seg_auto_pecas}
                  onChange={(event: any) => this.obs.mva.seg_auto_pecas = event.target.checked}
                />
                <Checkbox
                  label={"Veterinário/pet"}
                  checked={this.obs.mva.seg_vet_pet}
                  onChange={(event: any) => this.obs.mva.seg_vet_pet = event.target.checked}
                />
                <Checkbox
                  label={"Refrigerantes"}
                  checked={this.obs.mva.seg_refrigerantes}
                  onChange={(event: any) => this.obs.mva.seg_refrigerantes = event.target.checked}
                />
                <Checkbox
                  label={"Aguas e outras bebidas"}
                  checked={this.obs.mva.seg_agua_out}
                  onChange={(event: any) => this.obs.mva.seg_agua_out = event.target.checked}
                />
                <Checkbox
                  label={"Lâmpadas, reatores e starter"}
                  checked={this.obs.mva.seg_lamp_reatores}
                  onChange={(event: any) => this.obs.mva.seg_lamp_reatores = event.target.checked}
                />
                <Checkbox
                  label={"Materiais de limpeza"}
                  checked={this.obs.mva.seg_mat_limpeza}
                  onChange={(event: any) => this.obs.mva.seg_mat_limpeza = event.target.checked}
                />
                <Checkbox
                  label={"Pneumáticos, câmaras de ar e protetores de borracha"}
                  checked={this.obs.mva.seg_pneumaticos_prot}
                  onChange={(event: any) => this.obs.mva.seg_pneumaticos_prot = event.target.checked}
                />
                <Checkbox
                  label={"Produtos alimentícios"}
                  checked={this.obs.mva.seg_alimenticios}
                  onChange={(event: any) => this.obs.mva.seg_alimenticios = event.target.checked}
                />
                <Checkbox
                  label={"Produtos de perfumaria e de higiene pessoal e cosméticos"}
                  checked={this.obs.mva.seg_perf_cosm}
                  onChange={(event: any) => this.obs.mva.seg_perf_cosm = event.target.checked}
                />
                <Checkbox
                  label={"Produtos eletrônicos, eletroeletrônicos e eletrodomésticos"}
                  checked={this.obs.mva.seg_eletro}
                  onChange={(event: any) => this.obs.mva.seg_eletro = event.target.checked}
                />
                <Checkbox
                  label={"Rações para animais domésticos"}
                  checked={this.obs.mva.seg_racoes}
                  onChange={(event: any) => this.obs.mva.seg_racoes = event.target.checked}
                />
                <Checkbox
                  label={"Sorvetes e preparados para fabricação de sorvetes em máquinas"}
                  checked={this.obs.mva.seg_sorvetes_fab}
                  onChange={(event: any) => this.obs.mva.seg_sorvetes_fab = event.target.checked}
                />
                <Checkbox
                  label={"Tintas e vernizes"}
                  checked={this.obs.mva.seg_tintas}
                  onChange={(event: any) => this.obs.mva.seg_tintas = event.target.checked}
                />
                <Checkbox
                  label={"Material de construção"}
                  checked={this.obs.mva.seg_mat_construcao}
                  onChange={(event: any) => this.obs.mva.seg_mat_construcao = event.target.checked}
                />
                <Checkbox
                  label={"Veículos automotores novos"}
                  checked={this.obs.mva.seg_veiculos_automotores}
                  onChange={(event: any) => this.obs.mva.seg_veiculos_automotores = event.target.checked}
                />
                <Checkbox
                  label={"Veículos novos de duas e três rodas motorizados"}
                  checked={this.obs.mva.seg_veiculos_novos}
                  onChange={(event: any) => this.obs.mva.seg_veiculos_novos = event.target.checked}
                />
                <Checkbox
                  label={"Medicamentos de uso humano e outros produtos farmacêuticos"}
                  checked={this.obs.mva.seg_medicamentos_humano}
                  onChange={(event: any) => this.obs.mva.seg_medicamentos_humano = event.target.checked}
                />
              </div>
            </FormGroup>
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Cancelar" onClick={() => this.obs.open_select_segments = false} />
              <Button
                text="Salvar"
                intent="primary"
                onClick={() => {
                  this.obs.open_select_segments = false;
                }}
              />
            </div>
          </div>
        </Dialog>
      </>
    );
  }
}
